<template>
  <div class="myenroll">
    <TopNavBar navtitle="我的报名"></TopNavBar>

    <div class="enrolllist">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="onLoad"
        :offset="10"
      >
        <van-tabs
          v-model="active"
          class="newstopnav"
          title-active-color="#fa195a"
        >
          <van-tab title="所有报名"></van-tab>
          <van-tab title="未缴费"></van-tab>
          <van-tab title="已缴费"></van-tab>
        </van-tabs>
        <van-cell
          v-for="item in active == 0
            ? MyExamForm
            : active == 1
            ? MyExamForm.filter(s => s.IsPay == 0)
            : MyExamForm.filter(s => s.IsPay == 1)"
          :key="item.EF_ID"
        >
          <ul class="Enrollphoto">
            <h1>{{ item.ExamBatch.EB_Name }}</h1>
            <img class="papers" :src="item.Photo" :alt="item.Name" />
            <i
              class="iconfont icon-baomingchenggong"
              v-if="item.S_PayOrder != undefined && item.S_PayOrder.IsPay == 1"
            ></i>
            <li>
              <label for> <i class="iconfont icon-baoming"></i>报考人： </label>
              <span>{{ item.Name }}</span>
            </li>
            <li>
              <label for> <van-icon name="location-o" />考试地点： </label>
              <span class="info">{{ item.ExamArea.EA_Name }}</span>
            </li>
            <li>
              <label style="margin-left: 22px;"> 考试方式： </label>
              <span class="fee">{{
                item.IsOnline == 1 ? "线上" : "线下"
              }}</span>
            </li>
            <li>
              <label for>
                <i class="iconfont icon-zhuanye"></i>报考专业：
              </label>
              <span class="info">{{ item.Majors.MName }}</span>
            </li>
            <li>
              <label for>
                <i class="iconfont icon-dengji"></i>报考等级：
              </label>
              <span class="info">{{ item.Grades.GName }}</span>
            </li>
            <li>
              <label for> <i class="iconfont icon-feiyong"></i>报名费： </label>
              <van-tag
                round
                type="danger"
                v-if="
                  item.S_PayOrder == undefined || item.S_PayOrder.IsPay != 1
                "
                >未支付</van-tag
              >
              <van-tag
                round
                type="success"
                v-if="
                  item.S_PayOrder != undefined && item.S_PayOrder.IsPay == 1
                "
                >已支付</van-tag
              >
              <span class="fee" v-if="item.Fee > 0">￥{{ item.Fee }}</span>
            </li>
            <li>
              <p
                class="paydetail"
                v-if="item.ExamBatch.EB_ID < 22 && item.ExamBatch.EB_ID != 15"
              >
                费用包含：报名费10元，证书费20元及{{
                  item.Grades.GName
                }}考务费{{ item.Fee - 30 }}元
              </p>
              <p class="paydetail" v-else>
                费用包含：报名费{{ 50 }}元和{{ item.Grades.GName }}考务费{{
                  item.Fee - 50
                }}元。
              </p>
            </li>
            <li>
              <label for> <i class="iconfont icon-riqi"></i>报名时间： </label>
              <span>{{ item.CreateTime }}</span>
            </li>
            <li>
              <label for>
                <i class="iconfont icon-shenhe2"></i>审核结果：
              </label>
              <van-tag round type="success" v-if="item.CheckStatus == 1"
                >已通过</van-tag
              >
              <span class="notpass" v-if="item.CheckStatus == 2">
                <van-tag round type="danger">未通过</van-tag>
                <div v-if="item.CheckRemark != ''">
                  {{
                    item.CheckRemark.indexOf("】:") !== -1
                      ? item.CheckRemark.split("】:")[1]
                      : item.CheckRemark
                  }}
                </div>
              </span>

              <van-tag round type="warning" v-if="item.CheckStatus == 0"
                >审核中...</van-tag
              >
            </li>
            <li class="btn-gather">
              <van-button
                type="primary"
                v-if="
                  item.IsOnline == 0 &&
                    item.S_PayOrder != undefined &&
                    item.S_PayOrder.IsPay == 1
                "
                :to="'/SetOfflineExamTracks?EF_ID=' + item.EF_ID"
                >选择考试曲目
              </van-button>
            </li>
            <li class="btn-gather">
              <!-- <van-button type="primary" v-if="item.S_PayOrder!=undefined&&item.S_PayOrder.IsPay==1" size="small" :to="{path:'/AdmissionTicket?EF_ID=' +item.EF_ID  }"> -->
              <van-button
                type="primary"
                v-if="
                  item.S_PayOrder != undefined && item.S_PayOrder.IsPay == 1
                "
                size="small"
                @click="OpenTicket(item.EF_ID)"
              >
                <i class="iconfont icon-zhunkaozheng"></i>准考证
              </van-button>
              <van-button
                type="info"
                size="small"
                :to="{ path: '/EnrollDetails?EF_ID=' + item.EF_ID }"
              >
                <i class="iconfont icon-xiangqing"></i>报名详情
              </van-button>
              <van-button
                type="warning"
                size="small"
                @click="UpdatePhoto(item)"
              >
                <i class="iconfont icon-pinglun1"></i>修改相片
              </van-button>
            </li>
          </ul>
        </van-cell>
      </van-list>
      <div
        class="no-data"
        v-if="
          !this.MyExamForm ||
            (active == 0
              ? MyExamForm
              : active == 1
              ? MyExamForm.filter(s => s.IsPay == 0)
              : MyExamForm.filter(s => s.IsPay == 1)
            ).length == 0
        "
      >
        <van-empty description="暂无信息" />
      </div>
    </div>
    <van-dialog
      v-model="show"
      title="修改证件照"
      message-align="left"
      confirm-button-text="完成"
    >
      <van-field name="IsPrevCert" label="近期免冠证件照">
        <template #input>
          <div>
            <van-uploader
              :after-read="afterUserPhotoRead"
              v-model="UserPhoto"
              accept="image/jpg,image/png,image/jpeg"
              :max-count="1"
            />
          </div>
        </template>
      </van-field>
      <div class="upexplain" style="text-align: left">
        <h2>上传要求：</h2>
        <img src="../assets/sketch.jpg" width="100%" alt="" />
        <p>
          1、证件照将用于<b class="danger">人脸识别和证书制作</b
          >，如果上传的证件照不符合规范要求，后果自负!
        </p>
        <p>
          2、证件照为标准小二寸考生本人正面免冠彩色半身证件照（护照照片）,<b
            class="danger"
            >照片底色不限</b
          >。需照相馆正规图片文件<b class="danger">不能手机翻拍</b>。
        </p>
        <p>
          3、文件图像格式为JPEG，图像为24位RGB真彩色，纸质相片扫描分辨率不低于300DPI，图像文件大小范围不超过2M。
        </p>
      </div>
    </van-dialog>

    <van-dialog
      v-model="showTicket"
      className="Ticket"
      title="准考证"
      message-align="left"
      confirm-button-text="关闭"
    >
      <div>
        <Ticket :EF_ID="STEF_ID" v-if="showTicket"></Ticket>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import TopNavBar from "@/components/TopNavBar.vue";
import Ticket from "@/components/Ticket.vue";
import { GetMyExamFormList, UpdateExamFormPhoto } from "@/api/exam";
import { ImgUpload } from "@/api/public";
import { Toast } from "vant";
const defaultQuery = {
  PageIndex: 1,
  PageSize: 10
};

export default {
  components: {
    TopNavBar,
    Ticket
  },
  data() {
    return {
      loading: false,
      finished: false,
      active: 0,
      MyExamForm: [],
      query: Object.assign({}, defaultQuery),
      total: 0, //总共的数据条数
      show: false,
      showTicket: false,
      UserPhoto: [],
      EF_ID: 0,
      STEF_ID: 0
    };
  },
  created() {
    this.GetMyExamFormList();
  },
  methods: {
    OpenTicket(EF_ID) {
      this.STEF_ID = EF_ID;
      this.showTicket = true;
    },
    UpdatePhoto(examForm) {
      this.EF_ID = examForm.EF_ID;
      this.show = true;
      this.UserPhoto = [];
      this.UserPhoto.push({ url: examForm.Photo });
      console.log(this.UserPhoto);
      console.log("examForm :>> ", examForm);
    },
    afterUserPhotoRead(file) {
      if (file.file.size > 2048000) {
        Toast.fail({ message: "上传照片不能超过2MB" });
        return;
      }
      // 上传个人免冠证件照
      let data = new FormData();
      data.append("file", file.file);
      ImgUpload(data, { TypePath: "UserPhoto" }).then(res => {
        UpdateExamFormPhoto({
          EF_ID: this.EF_ID,
          Photo: res.OtherMsg.FilePath
        }).then(resp => {
          this.MyExamForm.filter(s => s.EF_ID == this.EF_ID)[0].Photo =
            res.OtherMsg.FilePath;
        });
      });
    },
    GetMyExamFormList() {
      GetMyExamFormList(this.query).then(res => {
        let rows = res.listData; //请求返回当页的列表

        this.loading = false;
        this.total = res.totalCount;

        if (rows == null || rows.length === 0) {
          // 加载结束
          this.finished = true;
          return;
        }
        // 数据合并
        this.MyExamForm = this.MyExamForm.concat(rows);
        if (this.MyExamForm.length >= this.total) {
          this.finished = true;
        }
      });
    },
    //滚动加载时触发，
    onLoad() {
      this.query.PageIndex++;
      this.GetMyExamFormList();
    }
  }
};
</script>

<style scoped>
.enrolllist h1 {
  padding: 15px 0;
}
.enrolllist .Enrollphoto .papers {
  width: 25vw;
  position: absolute;
  right: 1%;
  border: 1px solid #eee;
  padding: 1px;
}
.enrolllist ul.Enrollphoto {
  box-shadow: 2px 2px 5px #ccc;
}
.enrolllist ul.Enrollphoto li {
  justify-content: flex-start;
}
.enrolllist ul.Enrollphoto .icon-baomingchenggong {
  right: 1%;
  top: 5%;
  font-size: 12vw;
}
.enrolllist .van-list .van-cell::after {
  border: 0;
}
.Ticket {
  zoom: 80%;
}
.Ticket image {
  width: 40%;
}
.van-overflow-hidden .van-dialog .van-dialog__content > img {
  width: auto !important;
}
.paydetail {
  padding: 10px 15px 0 15px;
  color: #888;
  text-align: left;
  font-size: 3.2vw;
  line-height: 1.6;
}
</style>
